import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <p className="hero-subtitle">Your AI travel partner</p>
          <h1 className="hero-title">TRAVEZE</h1>
          <h2 className="hero-heading">Explore the World</h2>
          <p className="hero-description">
            Discover breathtaking destinations and create unforgettable memories with our AI-powered travel companion
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero; 